/**
 * Low Carb Program Configuration
 */

import timeZoneDetector from "jstimezonedetect";
import moment from "moment-timezone";
var langConfig = require('../../config/lang');

var appContextConfig = require('../../config/app-context');

var runtimeConfig = require('../../config/runtimeconf');
var locale = runtimeConfig.locale;
var runmode = runtimeConfig.runmode;
var ApplicationContext = runtimeConfig.appcontext;

import store from '../store'

import EnglishMessages from 'vee-validate/dist/locale/en'
import FrenchMessages from 'vee-validate/dist/locale/fr'

import 'moment/locale/en-gb';
import 'moment/locale/fr-ca';
import axios from 'axios'


const PusherKeyProduction = "08a356f17511d0fafcca";
const PusherKeyDevelopment = "8fe360eb7d9bddc31f19";
const RavenKey = "https://dadee211dac945449f35f678bccddf6d@sentry.io/1225412";
const RaygunKey =  "do4e8Y+t9xZRj5Wz0AODnw==";
const GoogleUACode = "UA-104677630-1";

const Timezone = timeZoneDetector.determine().name();
axios.defaults.headers.common["Timezone"] = Timezone;
axios.defaults.headers.common["applicationContext"] = ApplicationContext;

const DevelopmentMode = runmode !== 'production';

if(process.env.NODE_ENV === "development") {
  locale = "en-GB";
}


let language;

switch(locale) {
  case 'fr-CA':
    moment.locale('fr');
    language = "fr";
    store.commit('setLang', 'fr_ca');
    break;
  case 'en-CA':
    moment.locale('en');
    language = 'en';
    store.commit('setLang', 'en_ca');
    break;
  case 'en-GB':
    moment.locale('en');
    language = 'en';
    store.commit('setLang', 'en_gb');
    break;
  default:
    moment.locale('en');
    language = 'en';
    store.commit('setLang', 'en_gb');
    break;
}

const Configuration = {
  ApplicationContext: ApplicationContext,
  Application: ApplicationContext === 'lowcarbprogram' ? 'Low Carb Program' : 'Gro Health',
  RavenKey: RavenKey,
  RaygunKey: RaygunKey,
  GoogleCode: GoogleUACode,
  PusherKey: DevelopmentMode ? PusherKeyDevelopment : PusherKeyProduction,
  language: language,
  locale: locale,
  timezone: Timezone,
  apiUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/api/" : "https://www.lowcarbprogram.com/api/",
  siteUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/" : "https://www.lowcarbprogram.com/",
  appUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/app/" : "https://www.lowcarbprogram.com/app/",
  hcpCmsUrl: DevelopmentMode ? "https://test.lowcarbprogram.com/lc-hcp-cms/wp-json" : "https://www.diabetes.co.uk/lc-hcp-cms/wp-json",
  validationDictionary: {
    EnglishMessages,
    FrenchMessages
  },
  dateFormatting: {
    /**
     * Date format for graph labels
     * @param date
     */

    fromNow: function (date) {
      let utcDate = moment.utc(date);
      return utcDate.fromNow();
    },
    graphLabels: function (date) {
      let offset = new Date();
      let utcDate = moment.utc(date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
      return utcDate.format('Do MMM h:mm a');
    },
    foodDiaryDate: function (date) {
      let utcDate = moment.utc(date);
      return utcDate.format('dddd Do MMMM, YYYY');
    }
  },
  captchaSiteKey: DevelopmentMode ? "6LdqxDMeAAAAAPt4y63oA4ORBPdKwpMvHQKgwz8s" : "6LdqxDMeAAAAAPt4y63oA4ORBPdKwpMvHQKgwz8s",
  stripePublishableKey:  DevelopmentMode ? "pk_test_51L7zDVIGpQzdYFKYjU1YtGlgwjqDXvJYNMF0acPaY5E8XNOfEeDEGfXyhvoS8qgKPZWfzzolfu9NAYFQsAFIv2L800cQq0yf0M" : "pk_live_51L7zDVIGpQzdYFKYfR1WHrzio5aQhbh3dj6N5hKuvyMLtrceSoMhKRp1xl3c4qWzYLcaolOFbo89SCxuykUG2IX200iVLiYbn0"
};

export default Configuration;



// WEBPACK FOOTER //
// ./src/config/index.js